export const data = {
  logbookName: "Daily Log",
  logbookVersion: "1.0.0",
  primaryVerifiers: [],
  secondaryVerifiers: [],
  regulatory: 0,
  author: "",
  content: [
    {
      group: "ID1",
      layout: "horizontal",
      content: [
        {
          group: "ID2",
          layout: "horizontal",
          label: {
            text: "LOCATION",
            textAlign: "center",
            padding: "6px",
            style: "solid",
          },
          content: [
            {
              item: "1",
              component: "text",
            },
          ],
        },
        {
          group: "ID2",
          layout: "horizontal",
          label: {
            text: "COUNTRY",
            textAlign: "center",
            padding: "6px",
            style: "solid",
          },
          content: [
            {
              item: "2",
              component: "text",
            },
          ],
        },
        {
          group: "ID2",
          layout: "horizontal",
          label: {
            text: "DATE",
            textAlign: "center",
            padding: "6px",
            style: "solid",
          },
          content: [
            {
              item: "3",
              component: "text",
            },
          ],
        },
      ],
    },
    {
      group: "ID2",
      marginTop: "24px",
      layout: "horizontal",
      content: [
        {
          group: "ID2",
          layout: "horizontal",
          label: {
            text: "STERN TO",
            textAlign: "center",
            padding: "6px",
            style: "solid",
          },
          content: [
            {
              item: "1",
              component: "check",
            },
          ],
        },
        {
          group: "ID2",
          layout: "horizontal",
          label: {
            text: "ALONG SIDE",
            textAlign: "center",
            padding: "6px",
            style: "solid",
          },
          content: [
            {
              item: "2",
              component: "check",
            },
          ],
        },
        {
          group: "ID2",
          layout: "horizontal",
          label: {
            text: "ANCHORED",
            textAlign: "center",
            padding: "6px",
            style: "solid",
          },
          content: [
            {
              item: "3",
              component: "check",
            },
          ],
        },
      ],
    },
    {
      group: "ID3",
      layout: "vertical",
      marginTop: "24px",
      label: {
        text: "WATCHKEEPERS",
        textAlign: "center",
        padding: "6px",
        style: "solid",
      },
      content: [
        {
          group: "ID2",
          layout: "horizontal",
          copyRow: true,
          addRow: true,
          moveRow: true,
          deleteRow: true,
          content: [
            {
              item: "3",
              component: "list",
            },
            {
              item: "3",
              component: "list",
            },
            {
              item: "3",
              component: "list",
            },
          ],
        },
      ],
    },
    {
      group: "ID4",
      layout: "vertical",
      marginTop: "24px",
      content: [
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "CREW ON DUTY",
              width: "33.3%",
              textAlign: "center",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "CREW OFF DUTY",
              width: "33.3%",
              textAlign: "center",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "DAY OFF",
              width: "16.9%",
              textAlign: "center",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "HOL",
              width: "16.5%",
              textAlign: "center",
              style: "solid",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          copyRow: true,
          addRow: true,
          moveRow: true,
          deleteRow: true,
          content: [
            {
              item: "1",
              text: "#",
              width: "48px",
              minWidth: "48px",
              clear: true,
              function: "moveRow",
              component: "button",
            },
            {
              item: "1",
              width: "33.3%",
              component: "list",
            },
            {
              item: "2",
              width: "33.3%",
              component: "list",
            },
            {
              item: "3",
              width: "16.9%",
              component: "check",
            },
            {
              item: "4",
              width: "16.5%",
              component: "check",
            },
            {
              item: "1",
              text: "X",
              width: "48px",
              minWidth: "48px",
              function: "delRow",
              clear: true,
              component: "button",
            },
          ],
        },
      ],
    },
    {
      group: "ID5",
      layout: "vertical",
      marginTop: "24px",
      content: [
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "NARRATIVE",
              width: "66.6%",
              textAlign: "center",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "INITIAL",
              width: "33.4%",
              textAlign: "center",
              style: "solid",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          copyRow: true,
          addRow: true,
          moveRow: true,
          deleteRow: true,
          content: [
            {
              item: "1",
              width: "66.6%",
              component: "text",
            },
            {
              item: "2",
              width: "33.4%",
              component: "list",
            },
          ],
        },
      ],
    },
    {
      group: "ID5",
      layout: "vertical",
      marginTop: "24px",
      content: [
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "DRILLS AND SAFETY MEETINGS",
              textAlign: "center",
              style: "solid",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          copyRow: true,
          addRow: true,
          moveRow: true,
          deleteRow: true,
          content: [
            {
              item: "1",
              component: "text",
            },
          ],
        },
      ],
    },
    {
      group: "ID8",
      layout: "vertical",
      marginTop: "24px",
      content: [
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "SHORE CONNECTIONS",
              width: "34%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "Y",
              width: "33%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "N",
              width: "33%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "SHORE POWER",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "WATER",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "PHONE",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "INTERNET",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
            {
              item: "1",
              width: "33%",
              component: "check",
            },
          ],
        },
      ],
    },
    {
      group: "ID8",
      layout: "vertical",
      marginTop: "24px",
      content: [
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "",
              width: "34%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "TANK LEVELS AT 0800",
              width: "33%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "LITRES",
              width: "33%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "FUEL (TOTAL)",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "WATER",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "GREY WATER",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "BLACK WATER",
              width: "34%",
              textAlign: "left",
              padding: "6px",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
            {
              item: "1",
              width: "33%",
              component: "text",
            },
          ],
        },
      ],
    },
    {
      group: "ID8",
      layout: "vertical",
      marginTop: "24px",
      content: [
        {
          group: "ID4",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "label",
              text: "DAY WORKERS NAME",
              width: "30%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "CONTACT #",
              width: "20%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "DAILY RATE",
              width: "20%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
            {
              item: "1",
              component: "label",
              text: "EMAIL ADDRESS",
              width: "30%",
              textAlign: "center",
              padding: "6px",
              style: "solid",
            },
          ],
        },
        {
          group: "ID4",
          layout: "horizontal",
          copyRow: true,
          addRow: true,
          moveRow: true,
          deleteRow: true,
          content: [
            {
              item: "1",
              width: "30%",
              component: "text",
            },
            {
              item: "1",
              width: "20%",
              component: "text",
            },
            {
              item: "1",
              width: "20%",
              component: "text",
            },
            {
              item: "1",
              width: "30%",
              component: "text",
            },
          ],
        },
      ],
    },
  ],
};
